import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller } from 'swiper/modules';
import GLightbox from "glightbox";

import './audioplayer.js';
import './schoollist.js';

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    //force side to scroll to top when menu is opened to prevent scroll position bugs on mobile
    document.body.addEventListener('transitionend', () => {
        if (document.body.classList.contains('body--show')) {
            window.scrollTo(0, 0);
        }
    });

    // INIT SUBMENU TOGGLE
    const submenu_parents = document.querySelectorAll('.nav_link:has(.submenu)');
    submenu_parents.forEach(function (parent) {
        parent.addEventListener('click', () => {
            const submenu = parent.querySelector('.submenu');
            submenu.classList.toggle('expanded');
        });

        //Check if any of the submenu links is active or the parent is currently active
        const submenu_links = parent.querySelectorAll('.submenu_link');
        let isActive = parent.classList.contains('nav_link--active');
        submenu_links.forEach(function (link) {
            if (link.classList.contains('submenu_link--active')) {
                isActive = true;
            }
        });

        //If any link is active, expand the submenu
        if (isActive) {
            const submenu = parent.querySelector('.submenu');
            submenu.classList.add('expanded');
        }
    });

    // INIT TOGGLE BIOGRAPHY
    const toggleBiographyButtons = document.querySelectorAll('[data-behaviour="toggleBiography"]');
    toggleBiographyButtons.forEach(function (button) {
        button.addEventListener('click', () => {
            const teamMember = button.closest('.team-member');
            const biography = teamMember.querySelector('[data-role="biography"]');
            biography.classList.toggle('biography--expanded');
            button.classList.toggle('button--active');

            //Check if this team-member is the last of the row (cant use :nth-of-type because the column count changes dynamically)
            let isLastOfRow = false;
            //Check if the team member's right edge is at or beyond the container's right edge
            const container = teamMember.parentElement;
            const containerRect = container.getBoundingClientRect();
            const teamMemberRect = teamMember.getBoundingClientRect();
            if (teamMemberRect.right >= containerRect.right - 1) {
                //It's the last of the row
                isLastOfRow = true;
            }

            //Add extra class when last of row to adjust positioning
            if (isLastOfRow) {
                biography.classList.add('biography--last-of-row');
            } else {
                biography.classList.remove('biography--last-of-row');
            }

            //Update last-of row when resizing window
            window.addEventListener('resize', () => {
                const containerRect = container.getBoundingClientRect();
                const teamMemberRect = teamMember.getBoundingClientRect();
                if (teamMemberRect.right >= containerRect.right - 1) {
                    //It's the last of the row
                    biography.classList.add('biography--last-of-row');
                } else {
                    biography.classList.remove('biography--last-of-row');
                }
            });

            //Expand the biography to its scroll height and collapse all other biographies
            const allBiographies = document.querySelectorAll('[data-role="biography"]');
            allBiographies.forEach(function (bio) {
                if (bio !== biography) {
                    bio.classList.remove('biography--expanded');
                    const bioButton = bio.closest('.team-member').querySelector('[data-behaviour="toggleBiography"]');
                    if (bioButton) {
                        bioButton.classList.remove('button--active');
                    }
                    bio.style.maxHeight = null;
                } else  {
                    //Set max height to scroll height for smooth transition
                    if (bio.classList.contains('biography--expanded')) {
                        bio.style.maxHeight = bio.scrollHeight + "px";
                    } else {
                        bio.style.maxHeight = null;
                    }
                }
            });
        });
    });

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

            on: {
                init: function () {
                    setPaginationColor(this);
                },
                slideChange: function () {
                    setPaginationColor(this);
                }
            }
        });

        function setPaginationColor(swiperInstance) {
            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
            if (activeSlide) {
                const color = activeSlide.getAttribute('data-textcolor') || '';
                const pagination = slider.querySelector('.swiper-pagination');
                if (pagination && color) {
                    pagination.style.setProperty('--PaginationColor', color);
                }
            }
        }
    });

    // INIT VERTICAL SWIPER
    const verticalsliders = document.querySelectorAll('.vertical-swiper');
    verticalsliders.forEach(function (verticalslider) {
        const verticalswiper = new Swiper(verticalslider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            }
        });
    });

    // INIT SLIDER SWIPER
    const sliderswipers = document.querySelectorAll('.slider-swiper');
    sliderswipers.forEach(function (slider) {
        // Count the number of slides
        const slideCount = slider.querySelectorAll('.swiper-slide').length;
        // Only enable loop if there are 3 or more slides
        const enableLoop = slideCount >= 3;

        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: enableLoop,
            centeredSlides: true,
            slidesPerView: 'auto',

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                    spaceBetween: 10
                },
                // when window width is >= 480px
                480: {
                    spaceBetween: 20
                },
                // when window width is >= 640px
                640: {
                    spaceBetween: 30
                },
                1024: {
                    spaceBetween: 30
                }
            }
        });
    });

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });

    // Teaser Element
    var teaserbtns = document.querySelectorAll('.teaser-list-more-button[data-action="load-more"]');
    teaserbtns.forEach(function(btn) {
        var moreItems = btn.parentElement.parentElement.querySelectorAll('.teaser-item-wrap[data-more]');
        if (btn && moreItems.length) {
            var expanded = false;
            var textShow = btn.getAttribute('data-text-show') || 'Mehr anzeigen';
            var textHide = btn.getAttribute('data-text-hide') || 'Weniger anzeigen';
            btn.addEventListener('click', function() {
                expanded = !expanded;
                moreItems.forEach(function(item) {
                    if (expanded) {
                        item.classList.remove('is-hidden');
                    } else {
                        item.classList.add('is-hidden');
                    }
                });
                btn.textContent = expanded ? textHide : textShow;
                // Höhen nach dem Ein-/Ausblenden neu berechnen
                // Warten bis die CSS-Transition abgeschlossen ist (400ms) plus Buffer
                setTimeout(function() {
                    requestAnimationFrame(function() {
                        equalizeTeaserHeights();
                    });
                }, 450);
            });
        }
    });

    // Teaser Höhen angleichen
    function equalizeTeaserHeights() {
        const teaserLists = document.querySelectorAll('.teaser-list');

        teaserLists.forEach(function(list) {
            const wraps = Array.from(list.querySelectorAll('.teaser-item-wrap')).filter(function(item) {
                return !item.classList.contains('is-hidden');
            });

            if (wraps.length === 0) return;

            // .teaser-item Elemente aus den Wraps holen
            const items = wraps.map(function(wrap) {
                return wrap.querySelector('.teaser-item');
            }).filter(function(item) {
                return item !== null;
            });

            if (items.length === 0) return;

            // Erst alle Höhen zurücksetzen auf auto, um natürliche Höhe zu erhalten
            items.forEach(function(item) {
                item.style.height = 'auto';
                item.style.minHeight = '';
            });

            // Kurz warten, damit Browser die Höhen neu berechnen kann
            requestAnimationFrame(function() {
                // Items nach ihrer vertikalen Position (offsetTop) gruppieren
                // Items mit gleicher offsetTop sind in derselben Zeile
                const rows = [];
                items.forEach(function(item) {
                    const top = item.offsetTop;
                    let foundRow = false;

                    for (let i = 0; i < rows.length; i++) {
                        // Toleranz von 5px für mögliche Rundungsfehler
                        if (Math.abs(rows[i].top - top) < 5) {
                            rows[i].items.push(item);
                            foundRow = true;
                            break;
                        }
                    }

                    if (!foundRow) {
                        rows.push({ top: top, items: [item] });
                    }
                });

                // Für jede Zeile die maximale Höhe finden und anwenden
                rows.forEach(function(row) {
                    let maxHeight = 0;

                    row.items.forEach(function(item) {
                        // scrollHeight für die tatsächliche Inhaltshöhe verwenden
                        const height = Math.max(item.offsetHeight, item.scrollHeight);
                        if (height > maxHeight) {
                            maxHeight = height;
                        }
                    });

                    row.items.forEach(function(item) {
                        item.style.height = maxHeight + 'px';
                        item.style.minHeight = maxHeight + 'px';
                    });
                });
            });
        });
    }

    // Initiales Angleichen der Höhen
    equalizeTeaserHeights();

    // Bei Fenstergrößenänderung neu berechnen
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            equalizeTeaserHeights();
        }, 250);
    });

    // INIT READ MORE BUTTON
    const readMoreButtons = document.querySelectorAll('.read-more-btn');
    readMoreButtons.forEach(function(btn) {
        const section = btn.closest('.section_text_content');
        const truncated = section.querySelector('.text-truncated');
        const full = section.querySelector('.text-full');
        const truncatedHeight = truncated.scrollHeight + 25; // Add some buffer for padding/margin
        const fullHeight = full.scrollHeight;

        full.style.maxHeight = truncatedHeight + 'px';

        btn.addEventListener('click', function() {
            if (truncated && full) {
                if (section.classList.contains('expanded')) {
                    // Collapse
                    setTimeout(() => {
                        full.style.maxHeight = truncatedHeight + 'px';
                        section.classList.remove('expanded');
                        btn.textContent = btn.getAttribute('data-text-show') || 'Mehr lesen';
                        setTimeout(() => {
                            full.style.maxHeight = truncatedHeight + 'px';
                        }, 400);
                    }, 20);
                } else {
                    // Expand
                    // Set max-height to truncated height first, then animate to full height
                    section.classList.add('expanded');
                    setTimeout(() => {
                        full.style.maxHeight = fullHeight + 'px';
                        btn.textContent = btn.getAttribute('data-text-hide') || 'Weniger lesen';
                    }, 20);
                }
            }
        });
    });

    var _paq = window._paq = window._paq || [];
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        var u="https://matomo.atw.io/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '47']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();
});
